
function useOriginHook(){
    return {
        DICE : !window.origin.toLowerCase().includes("cleartrip.com"),
        CLEARTRIP : window.origin.toLowerCase().includes("cleartrip.com"),
    };
}

export default useOriginHook;